<template>
  <el-upload
    :action="action"
    :show-file-list="showFileList"
    :before-upload="beforeUpload"
    :accept="accept"
    v-bind="$attrs"
  >
    <slot
      ><el-button size="small">{{ this.$t('Common.clickUpload') }}</el-button></slot
    >
    <div class="el-upload__tip" v-if="$slots.tip"><slot name="tip"></slot></div>
  </el-upload>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      default: ''
    },
    showFileList: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    },
    // 文件最大可上传大小，默认2M
    maxSize: {
      type: Number,
      default: 2
    }
  },
  methods: {
    beforeUpload(file) {
      // 限制文件格式
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.'))
      if (!this.accept.includes(fileSuffix)) {
        this.$message.error(`${this.$t('Common.fileUploadTips2')}:${this.accept}`)
        return false
      }

      // 显示文件大小
      const isExceedSize = file.size / 1024 / 1024 < this.maxSize
      if (!isExceedSize) {
        this.$message.error(`${this.$t('Common.fileUploadTips1')}: ${this.maxSize}MB`)
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
